export default "__VITE_ASSET__89798c99__"